export default __webpack_public_path__ + "static/media/Boots of theEarth Mother.79becc74.jpg";